import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Accordion from '../components/Accordion';

const Faq = () => {
  return (
     
   <div className="main_wrap">   

     <Header />

     <div className="content-wrapper"> 
      
         <div className="breadcrumb-wrap bg-f br-2"> 
            <div className="container">
               <div className="breadcrumb-title text-center">
                  <h2>Frequently Asked Questions</h2>
                  <ul className="breadcrumb-menu list-style">
                     <li> <Link to="/">Home</Link></li>
                     <li>FAQ</li>
                  </ul>
               </div>
            </div>
         </div> 

         <section className="faq-wrap style4  ptb-100">
            <div className="container">
               <div className="row gx-5 justify-content-center">
                  <div className="col-lg-8">
                     <div className="faq-content">
                        <div className="content-title style1 text-center">
                           <span>Have Questions?</span>
                        </div>
                        
                         <Accordion />
                        
                     </div>
                  </div>
               </div>
            </div>
         </section>

     </div>

     <Footer />  

    </div>

  );
};

export default Faq;
